export enum StatusEnum {
  Published = 'published',
  Unpublished = 'unpublished',
  Withdrawn = 'withdrawn',
}
